export default "__VITE_ASSET__0d03ee0c__"